import {Component, Input, OnInit} from '@angular/core';
import {SubmitConfirmationCodeFormComponent} from '../../submit-confirmation-code-form/submit-confirmation-code-form.component';
import {trigger} from '@angular/animations';
import {smoothEnterLeaveAnimation} from '../../../../../shared/animations/custom-animations';
import {ForgotPasswordService} from '../../../../services/forgot-password.service';
import * as OtpOptions from '../../../../../shared/constants/otp-options.const';
import {PHONE_NUMBER_LIST} from 'src/main/resources/static/angular2/app/shared/constants/phone-numbers.const';
import {DomainNameParserService} from 'src/main/resources/static/angular2/app/shared/services/domain-name-parser.service';

@Component({
  selector: 'app-verify-confirmation-code-by-phone',
  templateUrl: './verify-confirmation-code-by-phone.component.html',
  styleUrls: [
    './verify-confirmation-code-by-phone.component.css',
    '../../../../../../assets/css/floating-labels.css'
  ],
  animations: [
    trigger('showVerificationCodeResentMessage', smoothEnterLeaveAnimation('100ms', '100ms')),
    trigger('submittedConfirmationCodeAlert', smoothEnterLeaveAnimation('100ms 300ms', '100ms'))
  ]
})
export class VerifyConfirmationCodeByPhoneComponent implements OnInit {

  resendVerificationSmsButtonClicked = false;
  customerServicePhone: string;

  @Input()
  public username: string;

  @Input()
  public phoneNumber: string;

  constructor(private forgotPasswordService: ForgotPasswordService,
              private domainNameParserService: DomainNameParserService) {
    this.customerServicePhone = PHONE_NUMBER_LIST[this.domainNameParserService.getState()];
  }

  ngOnInit(): void {
  }

  resendVerificationSms(confirmationCodeFormComponent: SubmitConfirmationCodeFormComponent): void {
    console.log('Resending verification sms with confirmation code...');
    this.resendVerificationSmsButtonClicked = true;

    this.forgotPasswordService.requestOneTimePassword(this.username, OtpOptions.SMS_OTP_OPTION, this.phoneNumber).subscribe(_ => {
      console.log('Requesting one time password by phone again...');
      confirmationCodeFormComponent.setSubmitConfirmationCodeErrorType(null);
    });
  }
}
